/* src/app/shared/contract/contract-item/contract-natio-nego/contract-natio-nego.component.scss */
.light-flex-card {
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  margin-bottom: 20px;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
}
.header-item-filters {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  margin-bottom: 15px;
}
.container {
  position: relative;
  min-height: 64px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  border-radius: 5px;
}
.natio-list-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  background-color: rgba(255, 255, 255, 0.85);
}
.item {
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 0;
  background-color: rgba(36, 70, 102, 0.05);
  border-radius: 5px;
  padding: 15px;
}
.item-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font: 400 12px FranceTV Brown;
  background-color: #FFF;
  border-radius: 5px;
  padding: 15px;
}
.item-header {
  display: flex;
  flex: 1;
  min-width: 0;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}
.item-header > span {
  color: #001A33;
}
.item-header .discountCode {
  flex-shrink: 0;
}
.item-header .discountLabel {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-header .date-range,
.item-header .ca {
  flex-shrink: 0;
  white-space: nowrap;
}
.item-actions {
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
}
.conditions-title {
  margin: 0 0 10px;
  font: 700 12px FranceTV Brown;
  color: #F03C64;
}
.condition-summary {
  background-color: #FFF;
  padding: 10px;
  border-radius: 5px;
}
.condition-summary-scroll {
  --condition-summary-header-height: 36px;
  --condition-summary-row-height: 32px;
  max-height: calc(var(--condition-summary-header-height) + 6 * var(--condition-summary-row-height));
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
.condition-summary-table {
  width: 100%;
  table-layout: fixed;
}
.condition-summary-table .mat-mdc-header-row {
  height: var(--condition-summary-header-height);
}
.condition-summary-table .mat-mdc-row {
  height: var(--condition-summary-row-height);
}
.condition-summary-table .mat-mdc-header-cell,
.condition-summary-table .mat-mdc-cell {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.condition-summary-table .mat-mdc-header-cell {
  background-color: #FFF;
}
.condition-summary-table .mat-column-category-number-1,
.condition-summary-table .mat-column-category-number-4 {
  width: 80px;
}
.condition-summary-table .mat-column-category-number-2 {
  width: 112px;
}
.condition-summary-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.conditions-empty-row {
  height: var(--condition-summary-row-height);
  font: 400 12px FranceTV Brown;
  color: rgba(0, 26, 51, 0.8);
}
@media (max-width: 1200px) {
  .container {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 600px) {
  .item-header {
    flex-wrap: wrap;
  }
  .item-header .discountLabel {
    flex-basis: calc(100% - 50px);
  }
}
@keyframes fadeOutLeft {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-100%);
  }
}
.mat-expansion-panel-header {
  height: 58px;
  padding: 0 15px 0 10px;
}
.mat-expansion-indicator {
  background-color: black;
}
.mat-expansion-panel-body {
  padding: 0 0 16px !important;
}
/*# sourceMappingURL=contract-natio-nego.component.css.map */
